import type { Contact } from '@nutralab/api';

import { getContacts } from './getContacts';

/** Whether the site has at least one social network or marketplace link (the mobile top bar shows them). */
export function hasSocialContacts(contacts: Contact[]): boolean {
    const { telegram, whatsapp, instagram, facebook, x, youtube, shopify, mercado_libre } = getContacts(contacts);
    return Boolean(telegram || whatsapp || instagram || facebook || x || youtube || shopify || mercado_libre);
}
